var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable, override } from 'mobx';
import { QuestionTypeLegacy } from '../../QuestionTypeLegacy';
export class MemorizePointsLegacy extends QuestionTypeLegacy {
    legacyFontSize = 18;
    legacyManualSend = 0;
    constructor(parent) {
        super(parent);
        makeObservable(this);
    }
    get legacyImagePlaces() {
        return [
            ['correctComment', this.question.ownAspect.commentCorrect],
            ['generalComment', this.question.ownAspect.comment],
            ['question', this.questionPart.inner],
            ['wrongComment', this.question.ownAspect.commentWrong],
        ];
    }
    get legacyCommentPlaces() {
        return [
            ['correct', this.question.ownAspect.commentCorrect],
            ['general', this.question.ownAspect.comment],
            ['wrong', this.question.ownAspect.commentWrong],
        ];
    }
}
__decorate([
    observable
], MemorizePointsLegacy.prototype, "legacyFontSize", void 0);
__decorate([
    observable
], MemorizePointsLegacy.prototype, "legacyManualSend", void 0);
__decorate([
    override
], MemorizePointsLegacy.prototype, "legacyImagePlaces", null);
__decorate([
    override
], MemorizePointsLegacy.prototype, "legacyCommentPlaces", null);
